export enum DurationUnitOptions {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year',
}

export enum DurationUnit {
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONT',
  YEAR = 'YEAR',
}



// WEBPACK FOOTER //
// ./src/app/models/duration-unit.enum.ts